/**
 * Client-side log sanitization.
 * Strips PII and control characters from error messages before console output.
 */

/** Strip control characters and truncate for safe logging. */
export function sanitizeForLog(val: string, maxLength = 200): string {
    // eslint-disable-next-line no-control-regex
    return val.replace(/[\x00-\x1F\x7F]/g, "").slice(0, maxLength);
}

/** Safely extract a loggable message from an unknown error, stripping user data. */
export function safeErrorMessage(error: unknown): string {
    if (error instanceof Error) {
        return sanitizeForLog(error.message);
    }
    if (typeof error === "string") {
        return sanitizeForLog(error);
    }
    return "Unknown error";
}
